import {
  Text,
  Box,
  Image,
  ListItem,
  theme,
  Modal,
  useDisclosure,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Flex,
  ListIcon,
  List,
  Heading,
} from '@everlywell/ui-kit';
import { CheckCircle } from '@phosphor-icons/react';
import React from 'react';

export type Item = {
  image: string;
  title: string;
  items: string[];
};

type Props = {
  openHandler: (x: boolean) => void;
  open: boolean;
  modalTitle: string;
  listOfItems: Item[];
};

export const MeasuredItems = ({ listOfItems }: Pick<Props, 'listOfItems'>) => (
  <>
    {listOfItems?.map((item) => (
      <Box key={item.title} marginBottom={10} marginLeft={[4, 6]}>
        <Box
          display="flex"
          flexDirection={'row'}
          marginBottom={3}
          gap={4}
          alignItems={'flex-start'}
          alignSelf={'stretch'}
          justifyContent={'space-between'}
        >
          <Flex flexDirection={'row'} gap={4} alignItems={'center'}>
            <Image
              boxSize={theme.fontSizes['3xl']}
              aria-hidden="true"
              src={item.image}
            />
            <Heading fontSize={'2xl'} as={'h3'}>
              {item.title}
            </Heading>
          </Flex>
          <Text fontSize={'2xl'} color="viridian.base">
            {item.items.length}
          </Text>
        </Box>
        <List display={'flex'} flexWrap={'wrap'} gap={4}>
          {item.items.map((marker) => (
            <ListItem
              key={marker}
              fontWeight={'light'}
              display={'flex'}
              gap={2}
              alignItems={'center'}
              width={['calc(50% - 16px)', 'calc(33.333% - 16px)']}
            >
              <ListIcon
                as={CheckCircle}
                color="viridian.light"
                height={'24px'}
                width={'24px'}
              />
              {marker}
            </ListItem>
          ))}
        </List>
      </Box>
    ))}
  </>
);

export const MeasuredItemsModal = ({
  modalTitle,
  listOfItems,
  open,
  openHandler,
}: Props) => {
  const { onClose } = useDisclosure();

  const handleModalClose = () => {
    openHandler(false);
    onClose();
  };
  return (
    <Box sx={{ fontFamily: 'body' }}>
      <Modal isOpen={open} onClose={handleModalClose} size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader
            as="h2"
            color="viridian.base"
            textAlign={'center'}
            marginTop={2}
            marginBottom={[10, 8]}
            fontSize={['3xl', '5xl']}
            fontWeight="medium"
          >
            {modalTitle}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <MeasuredItems listOfItems={listOfItems} />
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default MeasuredItemsModal;
